const activityConfig = {
	googleApi: false,
	outlookApi: false,
	hideShipTo: false,
	hideScheduleFor: false,
	hideScheduleForFilter: false,
	hideScheduleBy: false,
	hideAddContact: false,
	hideAddActivity: false,
	hideActivityModule: false,
	hideTimeZoneOptions: false,
	defaultTitleCustomerFirst: false,
	timezones: [
		{
			label: "Eastern Standard Time",
			id: "America/New_York"
		},
		{
			label: "Central Standard Time",
			id: "America/Chicago"
		},
		{
			label: "Mountain Standard Time",
			id: "America/Denver"
		},
		{
			label: "Pacific Standard Time",
			id: "America/Los_Angeles"
		},
		{
			label: "US/Hawaii",
			id: "US/Hawaii"
		}
	],
	activitiesExportTemplate: "ActivitiesExport",
	activitiesExportOrigin: "A2",
	minutesStep: 15
}

export default activityConfig;